import type { PolicyValidationData } from '@policyvision/contracts';

import { Client } from '@/common/services/Client';
import {
  ExtractedData,
  PolicyExtractedData,
} from '@/policy/types/PolicyCoverage';

export async function fetchExtractedDataFromPolicy(
  uuid: string,
): Promise<PolicyExtractedData> {
  const response = await Client.get<PolicyValidationData>({
    endpoint: `/policies/${uuid}`,
  });

  return assemblePolicyExtractedData(response.data);
}

function assemblePolicyExtractedData(
  response: PolicyValidationData,
): PolicyExtractedData {
  const extractedData: ExtractedData = {
    situations: response.extractedData?.situations,
    amendments: response.extractedData?.amendments
      ? response.extractedData.amendments.map((a, index) => ({
          ...a,
          kind: 'amendment',
          identifier: a.uuid ?? `amendment-${index}`,
        }))
      : [],
    policy: response.extractedData?.policy
      ? {
          ...response.extractedData.policy,
          kind: 'policy',
          identifier: response.extractedData.policy.uuid,
          overlayRectangles: response.extractedData.policy.properties
            .map((x) => x.overlay)
            .filter((x) => x.x != 0),
        }
      : undefined,
    assignment: response.extractedData?.assignment
      ? {
          ...response.extractedData.assignment,
          kind: 'assignment',
          identifier: response.extractedData.assignment.uuid,
          overlayRectangles: [
            response.extractedData.assignment.overlayRectangle,
          ],
        }
      : undefined,
    financialData: response.extractedData?.financialData
      ? {
          ...response.extractedData.financialData,
          kind: 'financialData',
          identifier: response.extractedData.financialData.uuid,
          overlayRectangles: [
            response.extractedData.financialData.overlayRectangle,
          ],
        }
      : undefined,
  };

  return {
    uuid: response.uuid,
    epicAccountUuid: response.epicAccountUuid,
    epicPolicyUuid: response.epicPolicyUuid,
    fileName: response.fileName,
    policyNumber: response.policyNumber,
    attachmentId: response.attachmentId,
    extractedData,
    extractionType: response.extractionType,
    validationResult: response.validationResult,
  };
}
